<h2 mat-dialog-title>
    <mat-icon class="title-icon">{{ mode === 'template' ? 'collections_bookmark' : 'content_copy' }}</mat-icon>
    {{ titleText }}
</h2>

<mat-dialog-content class="picker-content">
    <ng-container *ngIf="loading">
        <div class="picker-loading">
            <mat-progress-spinner mode="indeterminate" diameter="32"></mat-progress-spinner>
            <span>Loading…</span>
        </div>
    </ng-container>

    <ng-container *ngIf="!loading && errorMessage">
        <div class="picker-error">
            <mat-icon>error_outline</mat-icon>
            <span>{{ errorMessage }}</span>
        </div>
    </ng-container>

    <ng-container *ngIf="!loading && !errorMessage && rows.length === 0">
        <div class="picker-empty">{{ emptyText }}</div>
    </ng-container>

    <ul class="source-list" *ngIf="!loading && !errorMessage && rows.length > 0">
        <li *ngFor="let row of rows" class="source-row">
            <div class="source-row__main">
                <div class="source-row__title">
                    {{ row.title }}
                    <span
                        *ngIf="row.sourceTag"
                        class="source-chip"
                        [class.source-chip--system]="row.sourceTag === 'system'"
                        [class.source-chip--shared]="row.sourceTag === 'shared'"
                        [class.source-chip--org-private]="row.sourceTag === 'org-private'"
                    >{{ row.sourceLabel }}</span>
                </div>
                <div class="source-row__sub">{{ row.sub }}</div>
            </div>
            <div class="source-row__meta">
                <span class="meta-chip"><mat-icon>account_tree</mat-icon> {{ row.partCount }} parts</span>
            </div>
            <div class="source-row__actions">
                <button mat-flat-button color="primary" type="button" (click)="pick(row)">
                    <mat-icon>check</mat-icon>
                    Use this
                </button>
            </div>
        </li>
    </ul>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
</mat-dialog-actions>
